import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions - MilkDairy Farm</title>
      </Helmet>
      <div className="bg-gray-50 min-h-screen py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Terms & Conditions</h1>
            <p className="text-gray-500">Last updated: {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <div className="w-20 h-1 bg-green-500 mx-auto mt-4"></div>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Investment Terms</h2>
              <p className="text-gray-600 leading-relaxed">
                By investing with MilkDairy Farm, you agree to the following investment terms:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Minimum investment amount: ₹10,000 for Basic Plan, ₹10,00,000 for Standard Plan</li>
                <li>Lock-in period: 12 months from the date of investment</li>
                <li>Early withdrawal is not permitted before maturity</li>
                <li>Investment amount cannot be partially withdrawn</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Returns & Payouts</h2>
              <p className="text-gray-600 leading-relaxed">
                We offer guaranteed 60% returns per annum on all investment plans. Terms:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Returns are calculated on the principal investment amount</li>
                <li>Monthly payouts are credited to your wallet on the 1st of each month</li>
                <li>Returns are guaranteed and not market-linked</li>
                <li>Taxes may apply as per government regulations</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Payment & Verification</h2>
              <p className="text-gray-600 leading-relaxed">
                All investments must be made through approved payment methods:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Bank Transfer (NEFT/RTGS/IMPS)</li>
                <li>UPI Payment</li>
                <li>Payment proof (screenshot) and UID must be uploaded for verification</li>
                <li>Investment becomes active only after admin verification</li>
                <li>Verification typically takes 24-48 hours</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Withdrawal & Maturity</h2>
              <p className="text-gray-600 leading-relaxed">
                Upon maturity, you can withdraw your investment:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Principal amount + total returns will be credited to your wallet</li>
                <li>Withdrawal requests are processed within 3-5 business days</li>
                <li>Minimum withdrawal amount: ₹1,000</li>
                <li>Bank details must be verified before first withdrawal</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Risk Disclosure</h2>
              <p className="text-gray-600 leading-relaxed">
                While we guarantee returns, investors should be aware that:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Past performance does not guarantee future results</li>
                <li>Investment is subject to market risks</li>
                <li>Early withdrawal penalties may apply</li>
              </ul>
            </div>

            <div className="bg-yellow-50 rounded-xl p-6 border-l-4 border-yellow-500">
              <p className="text-gray-700">
                <strong className="text-yellow-700">⚠️ Important:</strong> By investing, you confirm that you have read and agree to all terms and conditions. For any queries, contact us at <span className="text-green-600">assetsdairyfarm@gmail.com
                </span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;